module.exports = __webpack_public_path__ + "static/media/form-screen1.fc882b4d.jpg";